import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { PaymentMethodCards } from '~/src/features/payments-abn/components/PaymentMethodCards';
import { pushDataLayer } from '~/src/features/payments-abn/components/SeasonTicketPayment/helpers';
import { updateSeasonTicket } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';
import { TState } from '~/src/store';

import PaymentFrame from '../PaymentFrame';

import ConnectButton from './components/ConnectButton';
import TicketConnectionPopup from './components/popups';
import HowItWorks from './components/popups/HowItWorks';
import TicketDetails from './components/TicketDetails';
import TicketsList from './components/TicketsList';

import { ActionsBlock, ActionSectionTitle, ActionSectionWrapper } from '~/src/features/payments-abn/styled';
import * as ST from './styled';

const SeasonTicketPayment = (): JSX.Element => {
    const dispatch = useDispatch();
    const isTablet = useMatchMediaByWidth(wideBreakpoints.tablet);

    const { wholesaleCheaperData, selectedTicket, paySumIsLoading, paySumIsError, frameUrl } = useSelector((state: TState) => ({
        wholesaleCheaperData: state.wholesaleCheaperData.wholesaleCheaperData,
        selectedTicket: state.seasonTicketPayment.seasonTicket,
        paySumIsError: state.seasonTicketPayment.paySumIsError,
        paySumIsLoading: state.seasonTicketPayment.paySumIsLoading,
        frameUrl: state.payment.result.frameUrl,
    }), shallowEqual);

    const { availableFlags = [], currentFlag = [] } = wholesaleCheaperData || {};
    const { paySum } = selectedTicket || {};

    const [isOpenPopup, setIsOpenPopup] = useState(false);

    const onOpenPopup = () => {
        setIsOpenPopup(true);
        pushDataLayer('subscription_details');
    };

    useEffect(() => {
        if (availableFlags.length) {
            const [initialTicket] = availableFlags;
            dispatch(updateSeasonTicket(initialTicket));
        }
    }, []);

    if (frameUrl) {
        return <PaymentFrame/>;
    }

    return (
        <ActionSectionWrapper>
            <ST.TitleWrapper>
                <ActionSectionTitle>Абонементы</ActionSectionTitle>
                <ST.IconWrapper onClick={onOpenPopup}>
                    <InfoCircleFlip size={isTablet ? 20 : 24}/>
                </ST.IconWrapper>
                <HowItWorks
                    isOpen={isOpenPopup}
                    onClose={() => setIsOpenPopup(false)}
                    tickets={availableFlags}
                />
            </ST.TitleWrapper>
            <ActionsBlock>
                <TicketsList
                    selectedTicket={selectedTicket}
                    tickets={availableFlags}
                />
                {!paySumIsLoading && (paySum || paySumIsError)
                    ? <>
                        <PaymentMethodCards/>
                        <TicketDetails/>
                    </>
                    : <ConnectButton data-test='connect-button'>
                        {`${currentFlag.length ? 'Продлить' : 'Подключить'} абонемент`}
                    </ConnectButton>
                }
                <TicketConnectionPopup/>
            </ActionsBlock>
        </ActionSectionWrapper>
    );
};

export default SeasonTicketPayment;
